export default __webpack_public_path__ + "static/media/image-team-members.29ea3022.jpg";